
function populate_vod_links() {

  jQuery(".watch").each(function() {
    var id = this.id.split("_")[1];
    jQuery('#'+this.id).load('http://198.214.231.100/external_schedule/populate_pegtv_link/' + id);
  });

  // Bind facebox to links.
  jQuery('a[rel="facebox"]').facebox()

  // The iFrame is not removed when the facebox is closed, do it manually.
  jQuery(document).bind( 'afterClose.facebox', function() {
    jQuery("iframe[id^='vod-player']").remove();
  });

}


/* jQuery(document).ready(function() {

  populate_vod_links();

}); */
